import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'
import { Resolution } from './types'

export function useGetByResolutionId(id?: string) {
  return useQuery({
    queryKey: ['resolution-by-resolution-id', id],
    queryFn: async () => {
      const { data } = await apiClient.get<Resolution>(`int/resolution/${id}`)
      return data
    },
    enabled: Boolean(id),
    refetchOnWindowFocus: false,
  })
}
